import { createPortal } from "react-dom";

import { CircularLoader, createDomRoot } from "@similarweb/ui-components";

import * as SC from "./styles";

const ModalLoaderId = "popupRootID_Activation_ModalLoader";

export const FullScreenLoader = () => {
    const portal = createDomRoot(ModalLoaderId, undefined);

    return createPortal(
        <SC.LoaderWrapper>
            <CircularLoader options={{}} />
        </SC.LoaderWrapper>,
        portal,
    );
};
